var _path, _path2, _line, _line2, _rect, _path3, _rect2, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeyondData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 133,
    viewBox: "0 0 160 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2019 31.0604C62.115 30.437 68.9492 27.3812 79.4932 20.5C90.0371 27.3812 96.8713 30.437 112.784 31.0604V67.529C112.784 78.384 109.934 89.4174 102.342 97.1545C96.179 103.435 89.4931 107.829 79.4932 113.159C69.4932 107.829 62.8073 103.435 56.6445 97.1545C49.0521 89.4174 46.2019 78.384 46.2019 67.529V31.0604Z",
    fill: "#FD4C00",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2393 45.552C82.0258 45.552 84.7002 46.6704 86.6729 48.6633C88.6457 50.6564 89.7549 53.3611 89.7549 56.1829V61.0139H68.7237V56.1829L68.7364 55.6555C68.8655 53.0258 69.957 50.5319 71.8067 48.6633C73.7794 46.6705 76.4529 45.5521 79.2393 45.552Z",
    fill: "#EFE4D2",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25.6964,
    y1: 60.5099,
    x2: 46.2028,
    y2: 60.5099,
    stroke: "#101010",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 112.786,
    y1: 60.5099,
    x2: 133.292,
    y2: 60.5099,
    stroke: "#101010",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 52.6587,
    width: 17.1963,
    height: 17.1963,
    fill: "#EFE4D2",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.529 66.2482L149.154 66.465L141.261 71.0216L140.886 71.2384L140.511 71.0216L132.618 66.465L132.243 66.2482V56.2687L132.618 56.0519L140.511 51.4952L140.886 51.2784L141.261 51.4952L149.154 56.0519L149.529 56.2687V66.2482Z",
    fill: "#EFE4D2",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1798,
    y: 61.5051,
    width: 27.8672,
    height: 23.5634,
    fill: "#EFE4D2",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4941 69.6021C81.5067 69.6022 83.1736 71.2864 83.1738 73.4087C83.1738 75.5312 81.5068 77.2162 79.4941 77.2163C77.4813 77.2163 75.8134 75.5313 75.8134 73.4087C75.8136 71.2863 77.4814 69.6021 79.4941 69.6021Z",
    fill: "#FD4C00",
    stroke: "#101010",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyondData);
export default __webpack_public_path__ + "static/media/beyond-data.1f48112e8a173a4ed6d70fa7345e879b.svg";
export { ForwardRef as ReactComponent };